import { render, staticRenderFns } from "./Dotlist.vue?vue&type=template&id=6ec53317&scoped=true&"
import script from "./Dotlist.vue?vue&type=script&lang=js&"
export * from "./Dotlist.vue?vue&type=script&lang=js&"
import style0 from "./Dotlist.vue?vue&type=style&index=0&id=6ec53317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec53317",
  null
  
)

component.options.__file = "Dotlist.vue"
export default component.exports